import { Button } from "antd";
import styled from "styled-components";

export const StyledWrapperSections = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #ffffff;

  @media (max-height: 811px) {
    padding-bottom: 35vh;
    height: 100%;
  }
`;

export const StyledWDCardWrapper = styled.div`
  display: flex;
  gap: 24px;
`;

export const StyledProjectTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 28px;
  justify-content: space-between;
  padding: 24px;
  padding-bottom: 0;
  margin-bottom: 0;
`;

export const StyledTitle = styled.div`
  display: flex;
  align-items: center;

  & .ant-typography {
    margin: 0;
  }
`;

export const StyledButton = styled(Button)`
  background: #007bfb;
  border-radius: 8px;
  width: 194px;
  height: 32px;
  padding: 4px 20px;
`;

export const StyledButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
`;
